const options = {
    autoHeight: true,
    grabCursor: true,
    keyboard: true,
    navigation: {
        prevEl: '.js-slider-testimonials-prev',
        nextEl: '.js-slider-testimonials-next',
        disabledClass: 'button--disabled',
    },
    spaceBetween: 20,
    slidesPerView: 'auto',
    breakpoints: {
        768: {
            slidesPerView: 'auto',
            spaceBetween: 30,
            autoHeight: false,
        },
        991: {
            slidesPerView: 2,
            spaceBetween: 30,
            autoHeight: false,
        },
    },
};

const sliderTestimonials = {
    init() {
        const elements = document.querySelectorAll('.js-slider-testimonials');

        if (!elements.length) return;

        elements.forEach((element) => {
            const {autoplay, loop, speed} = element.dataset;
            if (autoplay === '1') {
                options.autoplay = {delay: 200, disableOnInteraction: false};
                options.speed = speed > 0 ? speed : 2000;
            }

            if (loop === '1') {
                options.loop = true;
            }

            const Slider = slider.default;
            this.sliderTestimonials = new Slider(element, options);
        });
    },
};

export default sliderTestimonials;
